// ver1.0.1

// topタブ
$(window).on('load',function(){
  var windowWidth = $(window).width();
  $('#CollectionSection-template--18474395730117__featured_collection_8q8p9w .grid').insertAfter(".tab .tabContents .js-tamago");
  $('#CollectionSection-template--18474395730117__featured_collection_QfPQF7 .grid').insertAfter(".tab .tabContents .js-niku");
  $('#CollectionSection-template--18474395730117__featured_collection_pcw6hA .grid').insertAfter(".tab .tabContents .js-sakana");
  $('#CollectionSection-template--18474395730117__featured_collection_HQCLbt .grid').insertAfter(".tab .tabContents .js-kakou");
  $('#CollectionSection-template--18474395730117__featured_collection_r8kKbf .grid').insertAfter(".newItem .js-new");

  $('#CollectionSection-template--18474395730117__featured_collection_8q8p9w').parents('.shopify-section').hide();
  $('#CollectionSection-template--18474395730117__featured_collection_QfPQF7').parents('.shopify-section').hide();
  $('#CollectionSection-template--18474395730117__featured_collection_pcw6hA').parents('.shopify-section').hide();
  $('#CollectionSection-template--18474395730117__featured_collection_HQCLbt').parents('.shopify-section').hide();
  $('#CollectionSection-template--18474395730117__featured_collection_r8kKbf').parents('.shopify-section').hide();
});

// ヒーローヘッダー　100vhのスマホ対応
function setHeight() {
  let vh = window.innerHeight * 0.01;
}
setHeight();

var menuState = false;
var dropState = false;

window.addEventListener('load', function() {
  document.querySelectorAll('.mainSlider--typeB').forEach(function(origEl){
    // 複製してイベントごとリセット
    var cloneEl = origEl.cloneNode(true);
    origEl.parentNode.replaceChild(cloneEl, origEl);

    var $slider = $(cloneEl);
    var thumbSel = '.msThumbnail .msThumbnail__item';
    var cfg    = $slider.data();
    var arrow  = !(cfg.arrow === false || cfg.arrow === 'false');
    var isDown = false, swiped = false, startX, startY;

    $slider.closest('.mainSliderSec.moduleSec')
      .find(thumbSel)
      .each(function(i){ $(this).attr('data-index', i); });

    $slider.slick({
      autoplay:       true,
      arrows:         arrow,
      infinite:       true,
      swipe:          true,
      touchMove:      true,
      swipeToSlide:   true,
      touchThreshold: 1,
      draggable:      true
    });

    $slider.on('init', function(e, slick){
      var idx = slick.currentSlide;
      $slider.closest('.mainSliderSec.moduleSec')
        .find(thumbSel+'[data-index="'+idx+'"]')
        .addClass('thumbnail-current');
    });

    // ドラッグ検知＋クリック抑制
    $slider
      .on('mousedown touchstart', function(e){
        isDown = true; swiped = false;
        var ev = e.type==='touchstart' ? e.originalEvent.touches[0] : e;
        startX = ev.pageX; startY = ev.pageY;
      })
      .on('mousemove touchmove', function(e){
        if (!isDown) return;
        var ev = e.type==='touchmove' ? e.originalEvent.touches[0] : e;
        if (Math.abs(ev.pageX - startX) > 5 ||
            Math.abs(ev.pageY - startY) > 5) {
          swiped = true;
        }
      })
      .on('mouseup touchend mouseleave touchcancel', function(){
        isDown = false;
        setTimeout(function(){ swiped = false; }, 0);
      })
      .on('click', '.slick-slide a', function(e){
        if (swiped) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });

    $slider.closest('.mainSliderSec.moduleSec')
      .find(thumbSel)
      .on('click', function(){
        $slider.slick('slickGoTo', $(this).data('index'), false);
      });

    $slider.on('beforeChange', function(e, slick, curr, next){
      var ctx = $slider.closest('.mainSliderSec.moduleSec');
      ctx.find(thumbSel).removeClass('thumbnail-current');
      ctx.find(thumbSel+'[data-index="'+next+'"]')
         .addClass('thumbnail-current');
    });
  });
});




// SPのみアコーディオン
$(document).on("click", ".sp-toggle", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    $(this).next("ul").slideToggle();
    $(this).toggleClass("open");
  }
});

$(document).on("click", ".hdrSearch--toggle > span,.hdrSearch--toggle > a", function () {
  const $this = $(this);
  const $icon = $this.find(".material-icons");
  const iconText = $icon.text();

  $this.next().slideToggle();
  if (iconText === "search") {
    $icon.text("close");
  } else if (iconText === "close") {
    $icon.text("search");
  }

  return false;
});


// ナビゲーション　子要素展開
$(function () {
  var ua = navigator.userAgent;
  // タブレット・スマートフォン時
  if (
    ((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
      ua.indexOf("Mobile") > 0) ||
    ua.indexOf("iPad") > 0
  ) {
    $(".hasChildren > a")
      .on("mouseenter touchstart", function () {
        $(this).toggleClass("open");
        $(this).next("ul,.megaMenu").toggleClass("open");
        return false;
      })
      .on("mouseleave touchend", function () {
        return false;
      });
    $(".hasChildren .hasChildren--close > a").on(
      "mouseenter touchstart",
      function () {
        $(this).parents("ul").removeClass("open").prev("a").removeClass("open");
        return false;
      }
    );
  } else {
    // PC時
    $(".hasChildren")
      .on("mouseenter focusin", function () {
        $(this).children("a").addClass("open");
        $(this).children("ul,.megaMenu").addClass("open");
      })
      .on("mouseleave focusout", function () {
        $(this).children("a").removeClass("open");
        $(this).children("ul,.megaMenu").removeClass("open");
      });
  }
});

$(document).on('click', '.hasChildren--click > a,.hasChildren--click > span,.hasChildren--click > h3', function() {
  const $this = $(this);
  const $ul = $this.next('ul');

  if ($this.hasClass('open')) {
    $this.removeClass('open');
    $ul.removeClass('open').slideUp();
  } else {
    const $gNav = $this.closest('.gNav');
    $gNav.find('.hasChilds > span').removeClass('open');
    $gNav.find('.hasChilds > span').next('ul').removeClass('open').slideUp(0);
    $this.addClass('open');
    $ul.addClass('open').slideDown();
  }

  return false;
});


$(document).on("click", ".hasChildren--clickSP > h2", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    var next = $(this).next();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      next.removeClass("open");
      next.slideUp();
    } else {
      const all = $(this)
        .parents("li")
        .parents()
        .parents(".gNav")
        .find(".hasChilds > span");
      all.removeClass("open");
      all.next().removeClass("open").slideUp(0);
      $(this).addClass("open");
      next.addClass("open").slideDown();
    }
    return false;
  }
});

// マルチグリッド横スクロール
$(function () {
  $(".lightSlider .multiGrid").each(function () {
    const $grid = $(this);
    const $slider = $grid.parents(".lightSlider");

    $grid.after('<div class="prevBtn"></div>', '<div class="nextBtn"></div>');

    const $leftButton = $grid.next(".prevBtn");
    const $rightButton = $leftButton.next(".nextBtn");

    let width = 0;
    $grid.children("li").each(function () {
      width += $(this).outerWidth(true);
    });

    //右へ
    $rightButton.click(function () {
      $grid.animate({ scrollLeft: $grid.scrollLeft() + 600 }, 300);
      return false;
    });

    //左へスクロールで表示
    $grid.scroll(function () {
      if ($grid.scrollLeft() < width - $grid.width()) {
        $rightButton.fadeIn();
      } else {
        $rightButton.fadeOut();
      }
    });

    //左へ
    $leftButton.click(function () {
      $grid.animate({ scrollLeft: $grid.scrollLeft() - 600 }, 300);
      return false;
    });

    //右へスクロールで表示
    $leftButton.hide();
    $grid.scroll(function () {
      if ($grid.scrollLeft() > 0) {
        $leftButton.fadeIn();
      } else {
        $leftButton.fadeOut();
      }
    });
  });
});




// テキスト横スクロール
var spSwiperDone = false;
$(window).on("load resize", function (event) {
  if (
    window.innerWidth < 992 &&
    spSwiperDone == false &&
    $(".spSwiper").length
  ) {
    $(".spSwiper").slick({
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      variableWidth: true,
      touchMove: true,
      swipeToSlide: true,
      infinite: false,
    });

    spSwiperDone = true;
  }
});

// タブ切り替え
$(function() {
  $(".tabSwitch > li").on('click', function() {
    var $this = $(this);
    if (!$this.hasClass('active')) {
      $this.siblings().removeClass('active');
      $this.addClass('active');

      var tabNum = $this.index();
      var $tabContents = $this.closest(".tab").find(".tabContent");

      $tabContents.hide().eq(tabNum).fadeIn("500");
    }
  });
});

$(function() {
  if ($(".wow").length) {
    $(window).on("scroll", function () {
      $(".wow").each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > position - windowHeight + windowHeight / 4) {
          $(this).addClass("animated");
        }
      });
    });
  }
});

if (window.innerWidth < 767) {
  $(".cateList__hasChildren").click(function () {
    $(this).toggleClass("open").next().toggleClass("open").slideToggle();
    return false;
  });
}
